import * as ImagePicker from 'expo-image-picker';
import {Avatar, Box, Column, Pressable, Text, useDisclose} from 'native-base';
import {Keyboard, TouchableOpacity} from 'react-native';
import IcCamera from '@ui/svg/IcCamera';
import IcCircleCross from '@ui/svg/IcCircleCross';
import React from 'react';
import SelectMediaModal from '@ui/components/SelectMediaModal';
import {useTranslation} from 'react-i18next';

interface Props {
    imagePickerResult?: ImagePicker.ImagePickerAsset;
    setImagePickerResult: (imagePickerResult?: ImagePicker.ImagePickerAsset) => void;
}

const SelectAvatarButton = (props: Props) => {
    const {imagePickerResult, setImagePickerResult} = props;
    const {isOpen: isModalOpen, onClose: onCloseModal, onOpen: onOpenModal} = useDisclose();
    const {t} = useTranslation();

    const imageUri = imagePickerResult?.uri;

    const clearData = () => {
        setImagePickerResult(undefined);
    };

    const onOpen = async() => {
        Keyboard.dismiss();
        onOpenModal();
    };

    return (
        <>
            <TouchableOpacity onPress={onOpen}>
                <Column alignItems='center' justifyContent='center' w='full' space='2'>
                    <Box>
                        <Avatar size='xl' bg='secondary.100' borderColor='secondary.300' borderWidth={1} borderStyle='dashed' source={{uri: imageUri}}>
                            <IcCamera />
                        </Avatar>

                        {imageUri !== undefined && <Pressable variant='outline' position='absolute' top='0' right='0' onPress={clearData}><IcCircleCross /></Pressable>}
                    </Box>

                    <Text variant='mediumBody' color='primary.500'>{t('auth.avatar.addPhoto')}</Text>
                </Column>
            </TouchableOpacity>

            <SelectMediaModal isOpen={isModalOpen} onClose={onCloseModal} setResult={setImagePickerResult} />
        </>
    );
};

export default SelectAvatarButton;
